module.exports = __webpack_public_path__ + "img/EASG_Energiekongress_2027.25deb413.jpg";